var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogonew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8633 3.96969L15.159 1.28615L11.6468 4.77014V0.393555H7.82129V3.58846L13.035 8.76205L17.8633 3.96969Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81087 9.38038L7.12939 8.07201L8.51638 6.69568L3.68686 1.90332L0.982521 4.58801L4.49352 8.07201H0.0830078V11.8681H3.30268L5.81087 9.38038Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.975 11.8684H19.3855V8.07227H16.1647L13.6565 10.5612L12.3391 11.8684L10.9521 13.2459L15.7805 18.0371L18.486 15.3535L14.975 11.8684Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.821 12.556L6.43401 11.1797L1.60449 15.9709L4.31 18.6556L7.821 15.1716V19.547H11.6465V16.3521L9.13951 13.8632L7.821 12.556Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogonew);
export default __webpack_public_path__ + "static/media/logonew.059f45075c3bf7e26422a30f0aa42be5.svg";
export { ForwardRef as ReactComponent };